<template>
    <div class="empty-shopping-cart">
        <div class="empty-icon">
            <img src="../../public/img/empty.jpg">
        </div>
        <p class="empty-text">千万好物等待您的挑选</p>
    </div>
</template>

<script>
  export default {
    name: ''
  }
</script>

<style lang="scss" scoped>
.empty-shopping-cart {
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    margin-bottom: toRem(20);
    box-shadow: 0 1px 0 0 #E1E1E1;
    .empty-icon {
        width: toRem(400);
        height: toRem(400);
        margin: toRem(40) auto toRem(20);
        img {
            width: 100%;
            height: 100%;
        }
    }
    .empty-text {
        margin-bottom: toRem(100);
        font-family: PingFangSC-Light;
        font-size: toRem(28);
        color: #000;
        line-height: toRem(40);
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/EmptyShoppingCart/index.vue